module.exports = __webpack_public_path__ + "img/arrow-down.53370852.svg";